import { AgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";
import { AgTechUserProfile, AgTechUserProfileRoute } from "./AgTechUserProfileData";

export const UserDataGetMyProfileQuery: AgTechQuery<{ route: AgTechUserProfileRoute }, AgTechUserProfile> = {
    queryKey: (props) => ['MyProfile', props.route],
    query: (props) => {
        return props.http.getEntity({
            request: {
                path: props.inputData.route
            }
        });
    },
    content: {
        loadingText: 'Loading your profile...',
        failureText: 'Failed to load your profile.'
    }
}
